import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Mail = ({
  size,
  type,
  theme,
  className,
  dataTestId = "mail-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.93031 2.23505C1.53118 2.23505 0.396973 3.36926 0.396973 4.76838V11.2304C0.396973 12.6295 1.53119 13.7638 2.93031 13.7638H13.0676C14.4668 13.7638 15.601 12.6295 15.601 11.2304V4.76838C15.601 3.36926 14.4667 2.23505 13.0676 2.23505H2.93031ZM1.73031 4.76838C1.73031 4.10564 2.26756 3.56838 2.93031 3.56838H13.0676C13.7304 3.56838 14.2676 4.10564 14.2676 4.76838V5.66365L7.99952 8.89175L1.73031 5.66309V4.76838ZM1.73031 7.16285V11.2304C1.73031 11.8932 2.26757 12.4304 2.93031 12.4304H13.0676C13.7304 12.4304 14.2676 11.8932 14.2676 11.2304V7.16342L8.60998 10.0771C8.22691 10.2744 7.77212 10.2744 7.38905 10.0771L1.73031 7.16285Z"
    />
  </SVGIcon>
);
